import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
  {
    // default
    target: 'body',
    placement: 'center',
    // other
    contentTarget: 'div.ant-layout-sider-children>ul.ant-menu>li.ant-menu-item:nth-of-type(2)',
    content: <FormattedMessage id="onboarding.tutorial.discoverAndList" />,
    contentSide: 'right',
    expectedLocation: '/',
  },
  {
    // default
    target: 'body',
    placement: 'center',
    // other
    contentTarget: 'span.discover-button-tutorial',
    content: <FormattedMessage id="onboarding.tutorial.discover" />,
    contentSide: 'right',
    expectedLocation: '/discover',
    highlightArea: {
      width: 170,
      height: 51,
    },
    positionModifier: {
      addTop: -17,
      addLeft: -123,
    },
  },
  {
    // default
    target: 'body',
    placement: 'center',
    // other
    contentTarget: 'div.price-reference-buttons>div.amazon',
    content: <FormattedMessage id="onboarding.tutorial.amazon" />,
    contentSide: 'left',
    expectedLocation: '/discover/source',
    highlightArea: {
      width: 253,
      height: 136,
    },
    positionModifier: {
      addTop: -8,
      addLeft: -8,
    },
  },
  {
    // default
    target: 'body',
    placement: 'center',
    // other
    delay: 500,
    contentTarget: 'div.discoverInputsWrapper>div.discoverInputs>div:nth-of-type(1)',
    content: (
      <span style={{ wordBreak: 'break-word' }}>
        <FormattedMessage id="onboarding.tutorial.pasteUrl" />
        <br />
        <FormattedMessage id="onboarding.tutorial.ifItemFromAmazon" />
      </span>
    ),
    contentSide: 'right',
    expectedLocation: '/discover/ids',
    highlightArea: {
      width: 254,
      height: 289,
    },
    positionModifier: {
      addTop: -8,
      addLeft: -8,
    },
  },
  {
    // default
    target: 'body',
    placement: 'center',
    // other
    delay: 500,
    contentTarget: 'div.price-reference-buttons>div.ebay',
    content: <FormattedMessage id="onboarding.tutorial.ebay" />,
    contentSide: 'right',
    expectedLocation: '/discover/listingSelect',
    highlightArea: {
      width: 254,
      height: 137,
    },
    positionModifier: {
      addTop: -8,
      addLeft: -8,
    },
  },
  {
    // default
    target: 'body',
    placement: 'center',
    // other
    delay: 700,
    contentTarget: 'div.account-dropdown-tutorial>div>div:nth-of-type(2)>div',
    content: <FormattedMessage id="onboarding.tutorial.paypal" />,
    contentSide: 'right',
    expectedLocation: '/discover/selectAccount',
    highlightArea: {
      width: 324,
      height: 47,
    },
    positionModifier: {
      addTop: -12,
      addLeft: -8,
    },
  },
  {
    // default
    target: 'body',
    placement: 'center',
    // other
    delay: 700,
    contentTarget: 'div.select-strategy-tutorial>div>div:nth-of-type(2)>div',
    content: <FormattedMessage id="onboarding.tutorial.strategy" />,
    contentSide: 'topLeft',
    expectedLocation: '/discover/strategy',
    highlightArea: {
      width: 809,
      height: 340,
    },
    positionModifier: {
      addTop: -8,
      addLeft: -8,
    },
  },
];
